/* Produktseite: „Zurück zur Übersicht" + Scrollposition der Kollektion merken – 7 O'CLOCK
   Angelegt: 2026-09-30

   Kollektionsseite: merkt sich laufend die Scrollposition (sessionStorage).
   Produktseite: baut oben links im Galeriebild einen Link „‹ Zurück"
   (weiß auf dunklen Moodbildern, braun auf hellen Freistellern).
   Kam man von einer Kollektionsseite, geht es per history.back() zurück –
   der Browser stellt die Position wieder her; falls nicht (z. B. Seite neu
   geladen), scrollt die Kollektionsseite selbst an die gemerkte Stelle.
   Ohne Herkunft (Direktlink) führt die Pille zur ersten passenden Kollektion.

   Kollektionen des Produkts liefert snippets/gtm-head.liquid als
   window.ocProductCollections. Styles: assets/custom-product-back.css */
(function () {
  'use strict';

  var KEY = 'oc:collection-scroll';
  var path = location.pathname;

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function write(data) {
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }

  /* ---------- Kollektionsseite: Position merken + wiederherstellen ---------- */
  if (path.indexOf('/collections/') === 0) {
    var ticking = false;
    function save() {
      write({ path: path, y: Math.round(window.scrollY), t: Date.now() });
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; save(); }, 150);
    }, { passive: true });
    window.addEventListener('pagehide', save);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') save();
    });

    var saved = read();
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var fromProduct = /\/products\//.test(document.referrer || '');
    var isBack = nav.type === 'back_forward';

    if (saved && saved.path === path && saved.y > 0 && (fromProduct || isBack) && Date.now() - saved.t < 30 * 60 * 1000) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var target = saved.y;
      var start = Date.now();
      var settled = 0;
      (function restore() {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        var y = Math.min(target, Math.max(0, max));
        if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
        if (max >= target) settled++;
        if (settled < 3 && Date.now() - start < 3000) requestAnimationFrame(restore);
        else if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
      })();
    }
    return;
  }

  /* ---------- Produktseite: Pille im Galeriebild ---------- */
  if (path.indexOf('/products/') !== 0) return;

  var ICON = '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M9 2.5 4.5 7 9 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function pick() {
    var list = window.ocProductCollections || [];
    var ref = null;
    try {
      var u = new URL(document.referrer);
      if (u.origin === location.origin && u.pathname.indexOf('/collections/') === 0) ref = u;
    } catch (e) {}

    if (ref) {
      var handle = ref.pathname.split('/collections/')[1].split('/')[0];
      for (var i = 0; i < list.length; i++) {
        if (list[i].handle === handle) return { title: list[i].title, url: ref.pathname + ref.search, back: true };
      }
      return { title: 'Zurück zur Übersicht', url: ref.pathname + ref.search, back: true };
    }
    if (list.length) return { title: list[0].title, url: list[0].url, back: false };
    return null;
  }

  /* Helligkeit der Bildecke unter dem Link messen -> weiß oder braun */
  function activeImage(host) {
    var imgs = host.querySelectorAll('img');
    var hr = host.getBoundingClientRect();
    var cx = hr.left + hr.width / 2;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (r.width > 0 && r.left <= cx && r.right >= cx) return imgs[i];
    }
    return imgs[0] || null;
  }

  var lumCache = {};
  function tone(link, host) {
    var img = activeImage(host);
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    if (src in lumCache) { apply(link, lumCache[src]); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = 40, h = 40;
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        var ctx = canvas.getContext('2d');
        // Ausschnitt oben links (ca. 45 % Breite, 18 % Höhe) – dort sitzt der Link
        ctx.drawImage(probe, 0, 0, probe.naturalWidth * 0.45, probe.naturalHeight * 0.18, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h).data;
        var sum = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) {
          sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
          n++;
        }
        var lum = sum / n / 255;
        lumCache[src] = lum;
        apply(link, lum);
      } catch (e) { /* Bild nicht lesbar -> braun bleibt */ }
    };
    probe.src = src;
  }
  function apply(link, lum) {
    link.classList.toggle('is-light', lum < 0.72);
  }

  function build() {
    var host = document.querySelector('.product-header_image-component');
    if (!host || host.querySelector('.oc-back')) return !!host;
    var target = pick();
    if (!target) return true;

    var a = document.createElement('a');
    a.className = 'oc-back';
    a.href = target.url;
    a.setAttribute('aria-label', 'Zurück zu ' + target.title);
    a.innerHTML = ICON + '<span class="oc-back_label">Zurück</span>';

    a.addEventListener('click', function (e) {
      if (target.back && window.history.length > 1) {
        e.preventDefault();
        history.back();
      }
    });

    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.insertBefore(a, host.firstChild);

    // Farbe an das aktive Galeriebild anpassen, auch beim Weiterblättern
    tone(a, host);
    setTimeout(function () { tone(a, host); }, 800);
    var pending = null;
    function retone() {
      clearTimeout(pending);
      pending = setTimeout(function () { tone(a, host); }, 120);
    }
    host.addEventListener('scroll', retone, true);
    if (window.MutationObserver) {
      new MutationObserver(retone).observe(host, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'src', 'srcset'] });
    }
    return true;
  }

  if (!build()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (build() || ++tries > 40) clearInterval(timer);
    }, 250);
  }
})();
